// extracted by mini-css-extract-plugin
export var anchor = "_4z-0";
export var discard = "_4z-4";
export var muiTooltipTooltip = "_4z-6";
export var notificationBar = "_4z-3";
export var saveButtonHoverSlotWrapper = "_4z-5";
export var show = "_4z-2";
export var spacer = "_4z-1";